import { ComponentType } from "react";
import { PersonSexFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Пол человека — справочное значение: показывается локализованное название элемента
 * справочника, а не его код.
 */
export function PersonSex({
  data,
  whenEmpty,
}: {
  data?: Hidable<PersonSexFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(person) => (
        <LocalizedName data={person.sex?.value} whenEmpty={whenEmpty} />
      )}
    </Value>
  );
}
